@import 'igws-live-prices-carousel.default.less';

.dynamic-table {
  display: flex;
  gap: 1rem;
  padding: 1rem 0.5rem;
  width: max-content;
}

.main-container {
  width: max-content;
  animation: scroll var(--scroll-duration) linear infinite;
  display: flex;
}

.dynamic-table__epicsData .dynamic-table__fids .dynamic-table__cell {
  align-self: flex-end;
}

.dynamic-table .dynamic-table__row .dynamic-table__epicsData .dynamic-table__fids .dynamic-table__cell,
.dynamic-table .dynamic-table__iconrow .dynamic-table__epicsData .dynamic-table__fids .dynamic-table__cell {
  direction: ltr;
}

span[data-field='V2-F-BID'],
span[data-field='OFR'] {
  display: none;
}

@keyframes scroll {
  0% {
    transform: translateX(-0);
  }
  100% {
    transform: translateX(calc(50%));
  }
}
